import { useState } from "react";
import { Field, Select } from "@/components/base/FormControls";
import { useParametres } from "../ParametresProvider";
import { DEVISE_OPTIONS, FORMAT_DATE_OPTIONS, LANGUE_OPTIONS, type AgencePreferences } from "../types";

export default function PreferencesSection() {
  const { preferences, updatePreferences } = useParametres();
  const [form, setForm] = useState<AgencePreferences>(preferences);
  const [saved, setSaved] = useState(false);

  const update = <K extends keyof AgencePreferences>(key: K, value: AgencePreferences[K]) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setSaved(false);
  };

  const handleSave = () => {
    updatePreferences(form);
    setSaved(true);
  };

  return (
    <section className="flex flex-col rounded-lg border border-background-200 bg-background-50">
      <header className="flex items-center gap-2.5 border-b border-background-200 px-4 py-3.5 md:px-5">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-50 text-secondary-600">
          <i className="ri-equalizer-line text-base" aria-hidden="true" />
        </span>
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950 md:text-base">Préférences générales</h3>
          <p className="text-xs text-foreground-500">Langue, devise et format d'affichage des dates.</p>
        </div>
      </header>

      <div className="grid grid-cols-1 gap-4 p-4 md:grid-cols-3 md:p-5">
        <Field label="Langue" htmlFor="agence-pref-langue">
          <Select
            id="agence-pref-langue"
            value={form.langue}
            onChange={(event) => update("langue", event.target.value)}
            options={LANGUE_OPTIONS}
          />
        </Field>
        <Field label="Devise" htmlFor="agence-pref-devise">
          <Select
            id="agence-pref-devise"
            value={form.devise}
            onChange={(event) => update("devise", event.target.value)}
            options={DEVISE_OPTIONS}
          />
        </Field>
        <Field label="Format des dates" htmlFor="agence-pref-format">
          <Select
            id="agence-pref-format"
            value={form.formatDate}
            onChange={(event) => update("formatDate", event.target.value)}
            options={FORMAT_DATE_OPTIONS}
          />
        </Field>
      </div>

      <div className="flex flex-col-reverse gap-3 border-t border-background-200 px-4 py-4 md:flex-row md:items-center md:justify-between md:px-5">
        {saved ? (
          <p className="flex items-center gap-1.5 text-xs text-secondary-700">
            <i className="ri-checkbox-circle-line text-sm" aria-hidden="true" />
            Préférences enregistrées.
          </p>
        ) : (
          <span className="text-xs text-foreground-400">Ces préférences s'appliqueront à tout votre espace.</span>
        )}
        <button
          type="button"
          onClick={handleSave}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-save-line text-base" aria-hidden="true" />
          Enregistrer
        </button>
      </div>
    </section>
  );
}